export const disableScroll = () => {
  document.body.style.overflow = 'hidden';
};

export const enableScroll = () => {
  document.body.style.overflow = 'initial';
};
